export default __webpack_public_path__ + "static/Theindigenousrecipeforlivingwell-a3e5cc947760049e21d25cf68a9abc0b.jpg";